import { render, staticRenderFns } from "./workReport.vue?vue&type=template&id=b74d6c32&scoped=true&"
import script from "./workReport.vue?vue&type=script&lang=js&"
export * from "./workReport.vue?vue&type=script&lang=js&"
import style0 from "./workReport.vue?vue&type=style&index=0&id=b74d6c32&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b74d6c32",
  null
  
)

export default component.exports